import { CsvExportUtils, JsonExportUtils, XlsxExportUtils } from "@stellar/utils";
export async function exportDataByFormat({
  data,
  fileName,
  format
}) {
  switch (format) {
    case "CSV":
      CsvExportUtils.toFileDownload(data, `${fileName}.csv`);
      return;
    case "XLSX":
      await XlsxExportUtils.convertFileToXlsx({
        data,
        fileName
      });
      return;
    case "JSON":
      JsonExportUtils.exportData({
        data,
        fileName
      });
      return;
    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}